import { Button, DataTable, InputField, DropDownInput } from "@/components";
import { RightWrapper } from "../../../components";
import { FaPlus } from "react-icons/fa6";
import {
  fetchPickupAddresses,
  selectAllPickupAddresses,
} from "../../../app/Slices/pickupAddressSlice";
import { useCallback, useEffect, useMemo, useState } from "react";
import ColumnHelper from "@/utils/ColumnHelper";
import { useDispatch, useSelector } from "react-redux";
import { useFilteredData } from "@/";
import { StatesOptions, statesOptionsArray } from "../../../utils/Data.js";
import { useParams } from "react-router-dom";
const PickupAddress = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    pincode: "",
    city: "",
    state: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [resetPageCounter, setResetPageCounter] = useState(0);

  useEffect(() => {
    dispatch(fetchPickupAddresses({ userId: id }));
  }, []);
  const pickupAddresses = useSelector(selectAllPickupAddresses) || [];
  const handleChange = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);
  const filterConfig = useMemo(
    () => ({
      pincode: { type: "partial", itemKey: "pincode" },
      city: { type: "partial", itemKey: "city" },
      state: { type: "exact", itemKey: "state" },
    }),
    []
  );
  const { data: finalFilteredData, isLoading } = useFilteredData(
    pickupAddresses,
    appliedFilters,
    filterConfig
  );
  const isLoadingPickupAddress = useSelector(
    (state) => state.pickupAddress.loading
  );
  const handleApply = useCallback(() => {
    console.log("Filters applied:", filters);
    setAppliedFilters(filters);
    setResetPageCounter((prev) => prev + 1);
  }, [filters]);
  const handleReset = useCallback(() => {
    const initialFilters = {
      pincode: "",
      city: "",
      state: "",
    };
    setFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setResetPageCounter((prev) => prev + 1);
  }, []);
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Contact Name",
        accessorKey: "contactPerson", // Matches API response
        meta: {
          tooltip: (row) => row.contactPerson || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mobile",
        accessorKey: "contactPhone", // Matches API response
        meta: {
          tooltip: (row) => row.contactPhone || "N/A",
        },
      }),
      ColumnHelper({
        header: "Pick Address",
        accessorKey: "fullAddress", // Matches API response
        meta: {
          tooltip: (row) => row.fullAddress || "N/A",
        },
      }),
      ColumnHelper({
        header: "City",
        accessorKey: "city",
        meta: {
          tooltip: (row) => row.city || "N/A",
        },
      }),
      ColumnHelper({
        header: "Pincode",
        accessorKey: "pincode",
        meta: {
          tooltip: (row) => row.pincode || "N/A",
        },
      }),
      ColumnHelper({
        header: "State",
        accessorKey: "",
        cell: (info) => StatesOptions[info.row.original.state] || "N/A",
        meta: {
          tooltip: (row) => StatesOptions[row.state] || "N/A",
        },
      }),
    ],
    []
  );
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        {/* Header Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-end">
          <InputField
            label="Pincode"
            placeholder="Enter pincode"
            value={filters.pincode}
            onChange={(value) => handleChange("pincode", value)}
          />
          <InputField
            label="City"
            placeholder="Enter city"
            value={filters.city}
            onChange={(value) => handleChange("city", value)}
          />
          <DropDownInput
            label="State"
            value={filters.state}
            onChange={(value) => handleChange("state", value)}
            placeholder="Select your state"
            options={statesOptionsArray}
          />
          <div className="flex flex-row gap-2 justify-start items-end">
            <Button
              variant="default"
              size="md"
              onClick={handleApply}
              className="h-12"
            >
              Apply
            </Button>
            <Button
              variant="outline"
              size="md"
              className="h-12"
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-4 justify-between items-end"></div>
        <DataTable
          columns={columns}
          tittle="Pickup Address"
          isLoading={isLoadingPickupAddress}
          resetPage={resetPageCounter}
          data={finalFilteredData}
          showCheckbox={false}
        />
      </div>
    </RightWrapper>
  );
};

export default PickupAddress;
